import { HomeSectionHeader } from 'components/Header/HomeSectionHeader'
import { StyledHomeSection, StyledHomeSectionBody } from 'components/Header/HomeSectionHeader.styled'
import { Loader } from 'components/Loader'
import { useExpand } from 'hooks/useExpand'
import { useEffect, useState } from 'react'
import { Collapse } from 'react-bootstrap'
import { useDashboardStore } from 'store/useDashboardStore'
import { IGroundingOverviewData } from 'types/vehicleTypes'
import { getOrderNumber } from 'utils/utils'
import shallow from 'zustand/shallow'
import { GroundingImmediately } from './GroundingImmediately'
import { StyleGroundingOverview } from './GroundingOverview.styled'
import { GroundingSection } from './GroundingSection'
import { useGlobalStore } from 'store/useGlobalStore'
import { Rules } from 'common/rules'

export const GroundingOverview = ({ loading, widgetData, widgetLoading }) => {
  const [groundingData, setGroundingData] = useState([])
  const { state: expandState, action: expandAction } = useExpand({ componentOpen: true } as never)
  const { groundingData: data } = useDashboardStore((state) => state, shallow)
  const [isVisible, setIsVisible] = useState(true)
  const { componentOpen, groupOpen } = expandState
  const { setExpand, initGroup } = expandAction
  const isInRule = useGlobalStore((state) => state.isInRule, shallow)
  useEffect(() => {
    if (groundingData) {
      initGroup({ totalGroup: groundingData.length, initValue: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groundingData])

  useEffect(() => {
    if (!widgetLoading) {
      let orderNumber = getOrderNumber('WidgetDiv3_Grounding', widgetData)
      if (orderNumber === 0) return setIsVisible(false)
      if (data) {
        let groundingSectionData = [] as IGroundingOverviewData[]
        data?.groupHeader?.forEach((item) => {
          groundingSectionData.push({
            listOfVin: data?.ListOfVin,
            sectionName: item.headerText,
            filterField: item.filterField,
            filterValue: item.filterValue,
            vehicleDataList: item.subGroup,
            minDateAwaitingInspection: data?.MinDateAwaitingInspection,
            maxDateAwaitingInspection: data?.MaxDateAwaitingInspection
          } as IGroundingOverviewData)
        })
        setGroundingData(groundingSectionData)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, widgetLoading])

  return (
    <>
      {isVisible && (
        <StyledHomeSection>
          <HomeSectionHeader
            sectionTitle="Grounding Overview"
            onClick={() => {
              setExpand(!componentOpen)
            }}
            isExpand={componentOpen}
          />
          <Collapse in={true}>
            <StyledHomeSectionBody>
              <StyleGroundingOverview>
                {[Rules.VIEW_GROUNDING_QUICK_START].every((rule) => isInRule(rule)) && <GroundingImmediately />}
                {loading ? (
                  <Loader overlay />
                ) : (
                  <>
                    {groundingData?.map((item, index) => (
                      <GroundingSection
                        data={item}
                        isExpand={groupOpen[index]}
                        setExpand={() => setExpand(!groupOpen[index], index)}
                      />
                    ))}
                  </>
                )}
              </StyleGroundingOverview>
            </StyledHomeSectionBody>
          </Collapse>
        </StyledHomeSection>
      )}
    </>
  )
}
